import React, { memo, useEffect, useState } from "react";
// import { useDebounce } from "util";
import { SearchCountries } from "../../../slice/userThunks";
import { selCountriesInUser } from "../../../slice/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import { Typography, makeStyles } from "@material-ui/core";
import { TextField } from "app/components/common/TextField";
import { getAllCountries } from "store/slices/thunks";
import { selBaseCountries } from "store/slices";

export const NationalitySelector = memo(
  ({ onChange, error, helperText, className, disabled, required, value }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [inputValue, setInputValue] = useState("");
    const [countries, setCountries] = useState([]);
    const allCountries = useSelector(selBaseCountries);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
      let countryItems = allCountries.map((c) => ({
        title: c.name, //+${c.callingCodes[0]}
        // changed c.alpha3code --->c.name
        flag: c.flag,
        id: c.id,
        //   callingCode: c.callingCodes[0],
      }));

      setCountries(countryItems);
      return () => {};
    }, [allCountries]);

    useEffect(() => {
      if (value) {
        if (allCountries?.length) {
          let selected = allCountries.find(
            (c) =>
              c?.name === value ||
              c.alpha3Code === value ||
              c.alpha2Code === value
          );
          console.log(333, { selected });
          if (!selected) return;
          setInputValue(selected?.name);
        } else {
          handleFocus();
        }
      }
    }, [allCountries, value]);

    const handleFocus = () => {
      if (!allCountries?.length) onSearch(null);
    };

    function onSearch(payload) {
      dispatch(getAllCountries(payload));
    }
    /* -------------------------------------------------------------------------- */

    const renderLabel = (option) => {
      return `${option?.title}`;
    };
    const renderOption = (option) => {
      return (
        <div className={classes.countryItems}>
          <img
            src={option.flag}
            className={classes.flag}
            alt={option.title}
            loading="lazy"
          />
          <Typography>{option?.title}</Typography>
        </div>
      );
    };
    /* -------------------------------------------------------------------------- */
    return (
      <Autocomplete
        disabled={disabled}
        className={`${classes.autocomplete} ${className}`}
        classes={{
          popper: classes.popper,
          noOptions: classes.noOptions,
        }}
        options={countries}
        inputValue={inputValue}
        clearOnBlur={false}
        onFocus={handleFocus}
        disableClearable
        onChange={(event, newValue) => {
          if (!newValue) {
            onChange("");
            setInputValue("");
            return;
          }
          onChange(newValue.title);
          setInputValue(newValue.title);
        }}
        getOptionLabel={renderLabel}
        renderOption={renderOption}
        renderInput={(params) => (
          <TextField
            error={error}
            helperText={helperText ?? error}
            required={required ? required : null}
            {...params}
            id="textfield"
            label={"Nationality*"}
            variant="outlined"
            onChange={(e) => {
              let value = e.target.value;
              setInputValue(value);
              console.log({ onChangevalue: value });
              const hasOption = allCountries.some((option) =>
                String(`${option.title}`).includes(value)
              );
              if (hasOption && value.length === 0) {
                onChange(null);
              }
            }}
          />
        )}
      />
    );
  }
);
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
  autocomplete: {
    minWidth: 170,
    "& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root": {
      padding: 0,
    },
    "& .MuiAutocomplete-noOptions": {
      display: "none",
    },
  },
  popper: {
    width: "fit-content !important",
  },
  noOptions: {
    display: "none",
  },
  flag: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(0.5),
    objectFit: "contain",
  },
  countryItems: {
    display: "flex",
    flexDirection: "row",
  },
}));
